import(/* webpackMode: "eager" */ "/app/packages/frontend/app/[locale]/escape-room/[url]/page.jsx");
